import { sanitizeHTML } from "@/lib/utils";
import Link from "next/link";

interface PatientTestimonialsData {
  heading?: {
    text?: string;
    title?: string;
  };
  button?: {
    label?: string;
    href?: string;
  };
  reviews?: {
    reviews_id: {
      rating: number;
      author: string;
      comment: string;
    };
  }[];
}

export const fields = [
  // heading
  "heading.text",
  "heading.title",
  
  // button
  "button.label",
  "button.href",
  
  // reviews
  "reviews.reviews_id.rating",
  "reviews.reviews_id.author",
  "reviews.reviews_id.comment",
] as const;

interface PatientTestimonialsProps {
  data?: PatientTestimonialsData
}

export default function PatientTestimonials({ data }: PatientTestimonialsProps) {
  return (
    <section className="w-full bg-neutral-100 overflow-hidden">
      <div className="container mx-auto px-8 lg:px-16 py-8 lg:py-32">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-12 gap-6">
          <h2 className="text-[2rem] font-essonnes font-light leading-tight md:text-5xl lg:text-[3.375rem] text-primary">
            {data?.heading?.title}
          </h2>

          {data?.button && (
            <Link href={data.button.href || "#"} className="bg-primary text-white px-9 py-3.5 rounded-full font-greycliff w-fit">
              {data.button.label}
            </Link>
          )}
        </div>

        <div className="flex gap-5 overflow-x-auto pb-8 bader-h-scrollbar">
          {data?.reviews?.map((review, index) => {
            const reviewData = review.reviews_id;
            
            return (
              <div 
                key={index} 
                className={`flex-shrink-0 bg-white rounded-[1.25rem] border p-8 ${index % 2 === 0 ? 'w-[20.8rem] lg:w-[38rem]' : 'w-[20.8rem]'} flex flex-col justify-between`}
              >
                <div>
                  <div className="flex items-center gap-4 mb-6">
                    <div className="flex gap-1">
                      {[...Array(5)].map((_, i) => (
                        <svg 
                          key={i} 
                          className="w-5 h-5 text-yellow-400" 
                          fill="currentColor" 
                          viewBox="0 0 20 20"
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                    <span className="font-medium">{reviewData.rating}</span>
                  </div>
                  <p className="font-greycliff tracking-tight md:text-base md:leading-snug text-[1rem] font-normal leading-normal">
                    {reviewData.comment}
                  </p>
                </div>
                <p className="font-greycliff text-base text-right mt-8">{reviewData.author}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  )
} 